// source: type/order_alternative_items_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.AlternativeItemsRequest', null, global);
goog.exportSymbol('proto.type.AlternativeItemsRequest.NotRequested', null, global);
goog.exportSymbol('proto.type.AlternativeItemsRequest.RequestCase', null, global);
goog.exportSymbol('proto.type.AlternativeItemsRequest.Requested', null, global);
goog.exportSymbol('proto.type.AlternativeItemsRequest.Requested.ContactMethod', null, global);
goog.exportSymbol('proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call', null, global);
goog.exportSymbol('proto.type.AlternativeItemsRequest.Requested.ContactMethod.MethodCase', null, global);
goog.exportSymbol('proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AlternativeItemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.AlternativeItemsRequest.oneofGroups_);
};
goog.inherits(proto.type.AlternativeItemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AlternativeItemsRequest.displayName = 'proto.type.AlternativeItemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AlternativeItemsRequest.NotRequested = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.AlternativeItemsRequest.NotRequested, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AlternativeItemsRequest.NotRequested.displayName = 'proto.type.AlternativeItemsRequest.NotRequested';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AlternativeItemsRequest.Requested = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.AlternativeItemsRequest.Requested, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AlternativeItemsRequest.Requested.displayName = 'proto.type.AlternativeItemsRequest.Requested';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.AlternativeItemsRequest.Requested.ContactMethod.oneofGroups_);
};
goog.inherits(proto.type.AlternativeItemsRequest.Requested.ContactMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AlternativeItemsRequest.Requested.ContactMethod.displayName = 'proto.type.AlternativeItemsRequest.Requested.ContactMethod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.displayName = 'proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.displayName = 'proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.AlternativeItemsRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.type.AlternativeItemsRequest.RequestCase = {
  REQUEST_NOT_SET: 0,
  NOT_REQUESTED: 1,
  REQUESTED: 2
};

/**
 * @return {proto.type.AlternativeItemsRequest.RequestCase}
 */
proto.type.AlternativeItemsRequest.prototype.getRequestCase = function() {
  return /** @type {proto.type.AlternativeItemsRequest.RequestCase} */(jspb.Message.computeOneofCase(this, proto.type.AlternativeItemsRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AlternativeItemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AlternativeItemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AlternativeItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    notRequested: (f = msg.getNotRequested()) && proto.type.AlternativeItemsRequest.NotRequested.toObject(includeInstance, f),
    requested: (f = msg.getRequested()) && proto.type.AlternativeItemsRequest.Requested.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of AlternativeItemsRequest as accepted by the `fromObject` method.
 * @record
 */
proto.type.AlternativeItemsRequest.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.notRequested;

  /** @type {?|undefined} */
  this.requested;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AlternativeItemsRequest.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AlternativeItemsRequest}
 */
proto.type.AlternativeItemsRequest.fromObject = function(obj) {
  var msg = new proto.type.AlternativeItemsRequest();
  obj.notRequested && jspb.Message.setWrapperField(
      msg, 1, proto.type.AlternativeItemsRequest.NotRequested.fromObject(obj.notRequested));
  obj.requested && jspb.Message.setWrapperField(
      msg, 2, proto.type.AlternativeItemsRequest.Requested.fromObject(obj.requested));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AlternativeItemsRequest}
 */
proto.type.AlternativeItemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AlternativeItemsRequest;
  return proto.type.AlternativeItemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AlternativeItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AlternativeItemsRequest}
 */
proto.type.AlternativeItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.AlternativeItemsRequest.NotRequested;
      reader.readMessage(value,proto.type.AlternativeItemsRequest.NotRequested.deserializeBinaryFromReader);
      msg.setNotRequested(value);
      break;
    case 2:
      var value = new proto.type.AlternativeItemsRequest.Requested;
      reader.readMessage(value,proto.type.AlternativeItemsRequest.Requested.deserializeBinaryFromReader);
      msg.setRequested(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AlternativeItemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AlternativeItemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AlternativeItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotRequested();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.AlternativeItemsRequest.NotRequested.serializeBinaryToWriter
    );
  }
  f = message.getRequested();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.AlternativeItemsRequest.Requested.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AlternativeItemsRequest.NotRequested.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AlternativeItemsRequest.NotRequested.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AlternativeItemsRequest.NotRequested} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.NotRequested.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of NotRequested as accepted by the `fromObject` method.
 * @record
 */
proto.type.AlternativeItemsRequest.NotRequested.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AlternativeItemsRequest.NotRequested.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AlternativeItemsRequest.NotRequested}
 */
proto.type.AlternativeItemsRequest.NotRequested.fromObject = function(obj) {
  var msg = new proto.type.AlternativeItemsRequest.NotRequested();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AlternativeItemsRequest.NotRequested}
 */
proto.type.AlternativeItemsRequest.NotRequested.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AlternativeItemsRequest.NotRequested;
  return proto.type.AlternativeItemsRequest.NotRequested.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AlternativeItemsRequest.NotRequested} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AlternativeItemsRequest.NotRequested}
 */
proto.type.AlternativeItemsRequest.NotRequested.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AlternativeItemsRequest.NotRequested.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AlternativeItemsRequest.NotRequested.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AlternativeItemsRequest.NotRequested} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.NotRequested.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AlternativeItemsRequest.Requested.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AlternativeItemsRequest.Requested.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AlternativeItemsRequest.Requested} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.Requested.toObject = function(includeInstance, msg) {
  var f, obj = {
    contactMethod: (f = msg.getContactMethod()) && proto.type.AlternativeItemsRequest.Requested.ContactMethod.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Requested as accepted by the `fromObject` method.
 * @record
 */
proto.type.AlternativeItemsRequest.Requested.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.contactMethod;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AlternativeItemsRequest.Requested}
 */
proto.type.AlternativeItemsRequest.Requested.fromObject = function(obj) {
  var msg = new proto.type.AlternativeItemsRequest.Requested();
  obj.contactMethod && jspb.Message.setWrapperField(
      msg, 1, proto.type.AlternativeItemsRequest.Requested.ContactMethod.fromObject(obj.contactMethod));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AlternativeItemsRequest.Requested}
 */
proto.type.AlternativeItemsRequest.Requested.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AlternativeItemsRequest.Requested;
  return proto.type.AlternativeItemsRequest.Requested.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AlternativeItemsRequest.Requested} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AlternativeItemsRequest.Requested}
 */
proto.type.AlternativeItemsRequest.Requested.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.AlternativeItemsRequest.Requested.ContactMethod;
      reader.readMessage(value,proto.type.AlternativeItemsRequest.Requested.ContactMethod.deserializeBinaryFromReader);
      msg.setContactMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AlternativeItemsRequest.Requested.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AlternativeItemsRequest.Requested.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AlternativeItemsRequest.Requested} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.Requested.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContactMethod();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.AlternativeItemsRequest.Requested.ContactMethod.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.MethodCase = {
  METHOD_NOT_SET: 0,
  NO_CONTACT: 1,
  CALL: 2
};

/**
 * @return {proto.type.AlternativeItemsRequest.Requested.ContactMethod.MethodCase}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.getMethodCase = function() {
  return /** @type {proto.type.AlternativeItemsRequest.Requested.ContactMethod.MethodCase} */(jspb.Message.computeOneofCase(this, proto.type.AlternativeItemsRequest.Requested.ContactMethod.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AlternativeItemsRequest.Requested.ContactMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    noContact: (f = msg.getNoContact()) && proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.toObject(includeInstance, f),
    call: (f = msg.getCall()) && proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ContactMethod as accepted by the `fromObject` method.
 * @record
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.noContact;

  /** @type {?|undefined} */
  this.call;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.fromObject = function(obj) {
  var msg = new proto.type.AlternativeItemsRequest.Requested.ContactMethod();
  obj.noContact && jspb.Message.setWrapperField(
      msg, 1, proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.fromObject(obj.noContact));
  obj.call && jspb.Message.setWrapperField(
      msg, 2, proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.fromObject(obj.call));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AlternativeItemsRequest.Requested.ContactMethod;
  return proto.type.AlternativeItemsRequest.Requested.ContactMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact;
      reader.readMessage(value,proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.deserializeBinaryFromReader);
      msg.setNoContact(value);
      break;
    case 2:
      var value = new proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call;
      reader.readMessage(value,proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.deserializeBinaryFromReader);
      msg.setCall(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AlternativeItemsRequest.Requested.ContactMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNoContact();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.serializeBinaryToWriter
    );
  }
  f = message.getCall();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of NoContact as accepted by the `fromObject` method.
 * @record
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.fromObject = function(obj) {
  var msg = new proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact;
  return proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Call as accepted by the `fromObject` method.
 * @record
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.fromObject = function(obj) {
  var msg = new proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call;
  return proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional NoContact no_contact = 1;
 * @return {?proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.getNoContact = function() {
  return /** @type{?proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact} */ (
    jspb.Message.getWrapperField(this, proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact, 1));
};


/**
 * @param {?proto.type.AlternativeItemsRequest.Requested.ContactMethod.NoContact|undefined} value
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod} returns this
*/
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.setNoContact = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.AlternativeItemsRequest.Requested.ContactMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod} returns this
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.clearNoContact = function() {
  return this.setNoContact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.hasNoContact = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Call call = 2;
 * @return {?proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.getCall = function() {
  return /** @type{?proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call} */ (
    jspb.Message.getWrapperField(this, proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call, 2));
};


/**
 * @param {?proto.type.AlternativeItemsRequest.Requested.ContactMethod.Call|undefined} value
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod} returns this
*/
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.setCall = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.AlternativeItemsRequest.Requested.ContactMethod.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AlternativeItemsRequest.Requested.ContactMethod} returns this
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.clearCall = function() {
  return this.setCall(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AlternativeItemsRequest.Requested.ContactMethod.prototype.hasCall = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ContactMethod contact_method = 1;
 * @return {?proto.type.AlternativeItemsRequest.Requested.ContactMethod}
 */
proto.type.AlternativeItemsRequest.Requested.prototype.getContactMethod = function() {
  return /** @type{?proto.type.AlternativeItemsRequest.Requested.ContactMethod} */ (
    jspb.Message.getWrapperField(this, proto.type.AlternativeItemsRequest.Requested.ContactMethod, 1));
};


/**
 * @param {?proto.type.AlternativeItemsRequest.Requested.ContactMethod|undefined} value
 * @return {!proto.type.AlternativeItemsRequest.Requested} returns this
*/
proto.type.AlternativeItemsRequest.Requested.prototype.setContactMethod = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AlternativeItemsRequest.Requested} returns this
 */
proto.type.AlternativeItemsRequest.Requested.prototype.clearContactMethod = function() {
  return this.setContactMethod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AlternativeItemsRequest.Requested.prototype.hasContactMethod = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NotRequested not_requested = 1;
 * @return {?proto.type.AlternativeItemsRequest.NotRequested}
 */
proto.type.AlternativeItemsRequest.prototype.getNotRequested = function() {
  return /** @type{?proto.type.AlternativeItemsRequest.NotRequested} */ (
    jspb.Message.getWrapperField(this, proto.type.AlternativeItemsRequest.NotRequested, 1));
};


/**
 * @param {?proto.type.AlternativeItemsRequest.NotRequested|undefined} value
 * @return {!proto.type.AlternativeItemsRequest} returns this
*/
proto.type.AlternativeItemsRequest.prototype.setNotRequested = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.AlternativeItemsRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AlternativeItemsRequest} returns this
 */
proto.type.AlternativeItemsRequest.prototype.clearNotRequested = function() {
  return this.setNotRequested(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AlternativeItemsRequest.prototype.hasNotRequested = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Requested requested = 2;
 * @return {?proto.type.AlternativeItemsRequest.Requested}
 */
proto.type.AlternativeItemsRequest.prototype.getRequested = function() {
  return /** @type{?proto.type.AlternativeItemsRequest.Requested} */ (
    jspb.Message.getWrapperField(this, proto.type.AlternativeItemsRequest.Requested, 2));
};


/**
 * @param {?proto.type.AlternativeItemsRequest.Requested|undefined} value
 * @return {!proto.type.AlternativeItemsRequest} returns this
*/
proto.type.AlternativeItemsRequest.prototype.setRequested = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.AlternativeItemsRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AlternativeItemsRequest} returns this
 */
proto.type.AlternativeItemsRequest.prototype.clearRequested = function() {
  return this.setRequested(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AlternativeItemsRequest.prototype.hasRequested = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.type);
